import { useRouteNode, Link } from 'react-router5';

import SearchContact from '../explore/searchBar/searchContact';
import SearchEntities from '../explore/searchBar/searchEntities';
import Tab from '../components/tab/tab';


const ContactLinkFactory = ({id, children}) => {
  return <Link routeName={"carto.geo.contact"}
        routeOptions={{reload: true}}
        routeParams={{id:id}}
        key={id}>
    { children }
  </Link>
}


const EntityLinkFactory= ({id, children}) => {
  return <Link routeName={"carto.geo.entity"}
        routeOptions={{reload: true}}
        routeParams={{id:id}}
        key={id}>
    { children }
  </Link>
}


const AggView = ({ contacts, entities }) => {

  let { route: {name} } = useRouteNode('carto.geo.agg');

  name = name === "carto.geo.agg" ? name + ".contacts" : name;
  const [name_suffix] = name.split('.').reverse()

  const tabContent = [
    {"title": "Contacts", "root": "carto.geo.agg.contacts"},
    {"title": "Entités", "root": "carto.geo.agg.entities"},
  ];

  let view;

  if (name_suffix === "contacts") {
    view = <SearchContact dataList={contacts} LinkFactory={ContactLinkFactory} />
  } else if (name_suffix === "entities") {
    view = <SearchEntities dataList={entities} LinkFactory={EntityLinkFactory} />
  }

  // <section className="c-container container_one">{/*container 1*/}
  // </section>
  return <>
    <div className="c-container_menu">
      <Tab active={tabContent.map(x => x.root).indexOf(name)}>
        {tabContent.map((tab, idx) => (
            <Tab.TabPane key={`Tab-${idx}`} tab={tab.title} root={tab.root}></Tab.TabPane>)
          )
        }
      </Tab>
    </div> {/*menu  Tabs */}
    { view }
  </>
}

export default AggView
